import { render, staticRenderFns } from "./WebpartPersonalView.vue?vue&type=template&id=0c26cece"
import script from "./WebpartPersonalView.ts?vue&type=script&lang=ts&external"
export * from "./WebpartPersonalView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports